import TopPagesTable from "./TopPagesTable";

const TopPagesTab = ({ topPages }) => <TopPagesTable topPages={topPages} />;

export default TopPagesTab;
